import React from 'react';
import ReactPDF from '@react-pdf/renderer';
import {
  Text,
  Font,
  Page,
  View,
  Image,
  Document,
  StyleSheet,
} from '@react-pdf/renderer';

import Header from './pdf/content';
// import Content from './pdf/content';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    width: '595',
    height: "842",
    orientation: 'portrait',
  },
  footer:{
    height:"100px"
  }
});

Font.register({
  family: 'Open Sans',
  src: `https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0e.ttf`,
});

Font.register({
  family: 'Lato',
  src: `https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf`,
});

Font.register({
  family: 'Lato Bold',
  src: `https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf`,
});

const TaskList = tl => (
  <Page style={styles.page} wrap >
      <Header  data={tl}/>
     
      {/* <View fixed style={styles.footer}></View> */}
  </Page>
);

export default function PdfDocument(props) {
 return <Document>
        <TaskList size="A4"  {...props} />
      </Document>
}
// ReactPDF.render(<TaskList />, `${__dirname}/example.pdf`);